class BlogCarousel extends HTMLElement {
    constructor() {
    super();
    this.carouselElement = this;
    this.mobileOnly = this.dataset.mobileOnly === 'true';
    this.initCarousel();
    }

    initCarousel() {
    if (!this.carouselElement.classList.contains('splide')) return;

    // Check if it's a mobile device
    if (window.innerWidth <= 750 && this.mobileOnly) {
        this.carousel = new Splide(this.carouselElement, {
        perPage: 1, // Show one full slide at a time
        focus: 'center', // Center the current slide
        arrows: false, // No arrows for mobile
        pagination: false, // Custom progress bar and count instead of pagination
        autoWidth: false, // Avoid auto width
        fixedWidth: '86%', // Width of each slide, showing 86% of the current slide
        padding: {
            right: '15%' // Show 25% of the next slide
        }
        });

        this.initProgressBar(this.carousel);
        this.carousel.mount();

        this.updateSlideCount(this.carousel);
        this.carousel.on('moved', () => this.updateSlideCount(this.carousel));
    } else {
        // Desktop or larger screens - show all slides without the slider
        this.carouselElement.classList.remove('splide'); // Remove slider class

        const slidesContainer = this.querySelector('.splide__track');
        const slides = this.querySelectorAll('.splide__slide');

        // Reset slide container and slide styles for desktop view
        slidesContainer.style.display = 'flex';
        slidesContainer.style.flexWrap = 'wrap';
        slides.forEach(slide => {
        slide.style.display = 'inline-block'; // Display slides inline
        slide.style.width = 'calc(100% / ' + slides.length + ')'; // Ensure all slides fit evenly in container
        slide.style.flex = '1'; // Let each slide take full width of container
        });
    }
    }

    updateSlideCount(carousel) {
    const slideCountElement = this.querySelector('.blogs-splide__slide-count');
    if (!slideCountElement) return;

    const totalSlides = carousel.Components.Elements.slides.length;
    const currentSlide = carousel.index + 1;

    slideCountElement.textContent = `${currentSlide}/${totalSlides}`;
    }

    initProgressBar(carousel) {
    const bar = this.querySelector('.blog-my-slider-progress-bar');
    if (!bar) return;

    carousel.on('mounted move', function () {
        const end = carousel.Components.Controller.getEnd() + 1;
        const rate = Math.min((carousel.index + 1) / end, 1);
        bar.style.width = String(100 * rate) + '%';
    });
    }
}

customElements.define("blog-carousel-component", BlogCarousel);
  
  
  
